"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoomiOrderCancelRequestSchema = void 0;
const boomi_order_default_1 = require("./boomi-order-default");
const EVENT_INFO_DEFINITION = {
    properties: {
        isTrial: {
            type: 'boolean'
        },
        autoRenewStatus: {
            type: 'boolean'
        },
        cancellationDate: {
            type: 'string',
            minLength: 10
        },
        cancellationReason: {
            type: 'string'
        }
    },
    required: [
        'isTrial',
        'autoRenewStatus',
        'cancellationDate',
        'cancellationReason'
    ],
    type: 'object'
};
const EVENT_INFO_PROPERTY = {
    $ref: '#/definitions/EventInfo'
};
const EVENT_TYPE_DEFINITION = {
    enum: [
        'CANCELED_VIA_REQUEST',
    ],
    type: 'string'
};
const EVENT_TYPE_PROPERTY = {
    $ref: '#/definitions/EventType'
};
exports.BoomiOrderCancelRequestSchema = {
    ...boomi_order_default_1.BoomiOrderDefaultSchema,
    definitions: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.definitions,
        EventInfo: EVENT_INFO_DEFINITION,
        EventType: EVENT_TYPE_DEFINITION,
    },
    properties: {
        ...boomi_order_default_1.BoomiOrderDefaultSchema.properties,
        eventInfo: EVENT_INFO_PROPERTY,
        eventType: EVENT_TYPE_PROPERTY,
    }
};
//# sourceMappingURL=data:application/json;base64,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